import { render, staticRenderFns } from "./CollapsibleFilterPanel.vue?vue&type=template&id=5c031204&scoped=true&"
import script from "./CollapsibleFilterPanel.vue?vue&type=script&lang=js&"
export * from "./CollapsibleFilterPanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleFilterPanel.vue?vue&type=style&index=0&id=5c031204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c031204",
  null
  
)

export default component.exports